export default __webpack_public_path__ + "static/media/loading.85ac9402.svg";